"use strict";
/**
 * Types for Tournament Client
 */
Object.defineProperty(exports, "__esModule", { value: true });
